import { useEffect, useState } from "react";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";


const useFetchBOMID = (selectedProductID, isLoadProductDetail, callMessage) => {
  const [selectedbomID, setselectBOMID] = useState(null);
  const [sloading, setSLoading] = useState(false);
  const [serror, setSError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedProductID != null && selectedProductID !== 0) {
        setSLoading(true);
        try {
          const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_productvariety_id: selectedProductID,
          };

          const billOfMaterialResponse = await callApi(
            API_ENDPOINTS.BILL_MATERIAL_GET_ID,
            "POST",
            { "Content-Type": "application/json" },
            para
          );

          const billOfMaterialDet1 = billOfMaterialResponse[0];
          if (billOfMaterialDet1) {
            setselectBOMID(billOfMaterialDet1.id_bom);
          }
        } catch (err) {
          setSError(err);
          callMessage && callMessage("error", err.message, "Error");
        } finally {
          setSLoading(false);
        }
      }
    };

    fetchData();
  }, [selectedProductID, isLoadProductDetail, callMessage]);

  return { selectedbomID, sloading, serror };
};

export default useFetchBOMID;
